import { IPagesWithCategories } from "@/interfaces/page";
import React from 'react'

export const InternalOrExternalPage = ({ page, pathLang }: InternalOrExternalPageProps) => {

    return page.isExternalLink ? 
        <a target='_blank' href={page.url}>{page.menu || page.name}</a> : 
        <a href={`/${pathLang}${page.url}`}>{page.menu || page.name}</a>

}

interface InternalOrExternalPageProps{
    page: IPagesWithCategories;
    pathLang: string;
}